import { Table, TableColumnsType } from 'antd'

import { numberFormat } from '../../../../../utils'
import { getStatusLabel } from '../constants'
import { IOrderReportBucket } from '../types'

interface Props {
  data: IOrderReportBucket[]
  isLoading?: boolean
}

const ByStatusTable = ({ data, isLoading }: Props) => {
  const columns: TableColumnsType<IOrderReportBucket> = [
    {
      title: 'สถานะ',
      dataIndex: 'status',
      key: 'status',
      render: (status?: string) => getStatusLabel(status),
    },
    {
      title: 'จำนวนออเดอร์',
      dataIndex: 'count',
      key: 'count',
      align: 'right',
      render: (value: number) => numberFormat(value, 0),
    },
    {
      title: 'จำนวนชิ้น',
      dataIndex: 'quantity',
      key: 'quantity',
      align: 'right',
      render: (value: number) => numberFormat(value, 0),
    },
    {
      title: 'ยอด COD (฿)',
      dataIndex: 'codTotal',
      key: 'codTotal',
      align: 'right',
      render: (value: number) => numberFormat(value),
    },
    {
      title: 'ยอดโอน (฿)',
      dataIndex: 'transferTotal',
      key: 'transferTotal',
      align: 'right',
      render: (value: number) => numberFormat(value),
    },
    {
      title: 'ยอดรวม (฿)',
      dataIndex: 'grandTotal',
      key: 'grandTotal',
      align: 'right',
      render: (value: number) => numberFormat(value),
    },
  ]

  return (
    <Table
      rowKey={(record) => record.status ?? 'unknown'}
      columns={columns}
      dataSource={data}
      loading={isLoading}
      pagination={false}
      scroll={{ x: 'max-content' }}
    />
  )
}

export default ByStatusTable
